// Check box

import './CheckBox.scss';

export default function CheckBox({
  label,
  small,
  value,
  onChange,
  className,
  disabled,
  ariaLabel,
}) {
  return (
    <div
      className={
        'check-box pointer' +
        (small ? ' small' : '') +
        (className ? ' ' + className : '') +
        (disabled ? ' disabled' : '')
      }
      onClick={() => !disabled && onChange(!value)}
      role='checkbox'
      aria-checked={!!value}
      aria-disabled={!!disabled}
      aria-label={ariaLabel}
    >
      <div className='box'>
        <span className={'fa-check' + (value ? ' visible' : '')} />
      </div>
      <p className='label'>{label}</p>
    </div>
  );
}
